import * as React from "react";
import PropTypes from 'prop-types';

const SvgFshRedTruck = props => {
  if (props.id !== "_svgfshredtruck") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 26 15" fill="none" {...props}><g fill="#8C8279"><path d="M4.6 8.064H.8a.6.6 0 000 1.2h3.8a.6.6 0 000-1.2zM4.6 5.264H1.8a.6.6 0 100 1.2h2.8a.6.6 0 000-1.2zM4.6 2.464h-2a.6.6 0 000 1.2h2a.6.6 0 000-1.2z" /></g><path fillRule="evenodd" clipRule="evenodd" d="M25.608 6.904l-1.232-1.232a.312.312 0 01-.088-.136l-1.352-4a.128.128 0 00-.144-.096h-3.064V.704a.592.592 0 00-.384-.568 1.176 1.176 0 00-.288 0h-11.2a.528.528 0 00-.216.048l-.136.088a.536.536 0 00-.176.376l-1.272 10.6v.056a.568.568 0 00.568.576h1.904a2.664 2.664 0 015.311.104h4.025a2.664 2.664 0 015.319 0h2.033a.56.56 0 00.584-.576v-4a.599.599 0 00-.192-.504zm-5.88-4.352h2.264s.096 0 .112.08c.304.896.608 1.792.904 2.688v.096h-3.28V2.552z" fill="#E71324" /><circle cx={11.188} cy={12.156} r={2} fill="#8C8279" /><circle cx={20.563} cy={12.156} r={2} fill="#8C8279" /></svg>;
};

SvgFshRedTruck.displayName = "_svgfshredtruck";
SvgFshRedTruck.propTypes = {
  id: PropTypes.string
};
SvgFshRedTruck.defaultProps = {
  id: ''
};
export default SvgFshRedTruck;